export enum BillingMode {
  NexPark = 'NexPark',
  NexResponse = 'NexResponse',
}
